export default "assets/images/logo-dark-52fbc19f.png";